import { Article, Image } from './types';
import { Language } from './salesforce-types';

export interface SalesforceArticleLike {
  accArticleAssociationList?: { Account_Resource__r: unknown }[] | null;
  contentDistributionList?: { ContentDocumentId: string }[] | null;
  contentVersionList?:
    | {
        ALT_Text__c?: string;
        ALT_Text_Spanish__c?: string;
        ContentDocumentId: string;
        Mobile_Desktop_Image__c?: string;
      }[]
    | null;
  kav: {
    Display_Title__c?: boolean;
    Generic_Web_Page__c?: string;
    Generic_Web_Page_Order__c?: string;
    Generic_Web_Page_Section__c?: string;
    Generic_Web_Page_Sub_Section__c?: string;
    Id: string;
    Ignore_Tags__c?: boolean;
    Language?: Language | string;
    Link_Text__c?: string;
    Link_URL__c?: string;
    NULL_Version__c?: boolean;
    Summary__c?: string;
    Title: string;
    Web_Page_Order__c?: string;
    Web_Page_Section__c?: string;
    Web_Page_Sub_Section__c?: string;
    Web_Page_Sub_Subsection__c?: string;
    Web_Page_Tab__c?: string;
  };
  sourceArticleAssociationList?: { Source_Title__c: string; Source_URL__c: string }[] | null;
  tagArticleAssociationList?: { Tag_Name__c: string }[] | null;
}

export const isSalesforceArticleLike = (
  article: Article | SalesforceArticleLike,
): article is SalesforceArticleLike => !!(article as SalesforceArticleLike).kav;

export const convertSalesforceArticleToArticle = (sfArticle: SalesforceArticleLike): Article => {
  const sfOrder = sfArticle.kav.Web_Page_Order__c || sfArticle.kav.Generic_Web_Page_Order__c;
  const contentVersions = sfArticle.contentVersionList || [];
  let idDesktop = '';
  let idMobile = '';

  contentVersions.forEach(cv => {
    if (cv.Mobile_Desktop_Image__c) {
      if (cv.Mobile_Desktop_Image__c.toLowerCase() === 'desktop') {
        idDesktop = cv.ContentDocumentId;
      }

      if (cv.Mobile_Desktop_Image__c.toLowerCase() === 'mobile') {
        idMobile = cv.ContentDocumentId;
      }
    }
  });

  const images: Image[] = (sfArticle.contentDistributionList || []).map(item => {
    let desktopOrMobile: Image['desktopOrMobile'] = 'unknown';

    if (item.ContentDocumentId === idDesktop) {
      desktopOrMobile = 'desktop';
    }

    if (item.ContentDocumentId === idMobile) {
      desktopOrMobile = 'mobile';
    }

    const contentVersion = contentVersions.find(
      cv => cv.ContentDocumentId === item.ContentDocumentId,
    );

    return {
      url: item.ContentDocumentId,
      altText: '',
      altTextPayload: {
        [Language.En]: contentVersion?.ALT_Text__c || '',
        [Language.Es]: contentVersion?.ALT_Text_Spanish__c || '',
      },
      desktopOrMobile,
    };
  });

  return {
    id: sfArticle.kav.Id,
    title: sfArticle.kav.Title,
    bodyText: sfArticle.kav.Summary__c,
    linkText: sfArticle.kav.Link_Text__c,
    linkUrl: sfArticle.kav.Link_URL__c,
    tab: sfArticle.kav.Web_Page_Tab__c || sfArticle.kav.Generic_Web_Page__c,
    section: sfArticle.kav.Web_Page_Section__c || sfArticle.kav.Generic_Web_Page_Section__c,
    subSection:
      sfArticle.kav.Web_Page_Sub_Section__c || sfArticle.kav.Generic_Web_Page_Sub_Section__c,
    subSubsection: sfArticle.kav.Web_Page_Sub_Subsection__c,
    allPages: !!sfArticle.kav.Ignore_Tags__c,
    displayTitle: sfArticle.kav.Display_Title__c,
    order: sfOrder ? Number(sfOrder) : undefined,
    images,
    tags:
      sfArticle.tagArticleAssociationList?.map(
        tagArticleAssociation => tagArticleAssociation.Tag_Name__c,
      ) || [],
    accounts: sfArticle.accArticleAssociationList?.map(a => a.Account_Resource__r) || [],
    sources:
      sfArticle.sourceArticleAssociationList?.map(
        ({ Source_Title__c: title, Source_URL__c: url }) => ({
          title,
          url,
        }),
      ) || [],
    nullVersion: sfArticle.kav.NULL_Version__c,
    language: sfArticle.kav.Language || Language.En,
  } as Article;
};
